module.exports = __webpack_public_path__ + "img/3.11196b76.png";